import { useEffect, useRef, useState } from 'react';
import { IconArrowUpRight, IconSearch, IconX } from '@tabler/icons-react';
import { AppIcon, appsFor, searchApps, type AppKey } from '@hana/ui';
import s from './shell.module.css';
import { useT } from '@hana/i18n';

/** Nút ▦ chuyển vùng (MINT APPS KIT v1): lưới 6 vùng ngang hàng, tìm không dấu, chân "Tất cả vùng" về Hub.
 *  Ghế ADMIN thấy thêm ô HANA Kit (`admin`). Chỉ chuyển vùng qua đây — menu tài khoản không có lối tắt sang app khác. */
export function AppsMenu({ current, at, admin = false, onClose }: { current: AppKey; at: 'side' | 'rail' | 'float'; /** ghế ADMIN: thêm ô HANA Kit (MAPPS.adm) */ admin?: boolean; onClose: () => void }) {
  const t = useT();
  const [q, setQ] = useState('');
  const box = useRef<HTMLInputElement>(null);
  useEffect(() => box.current?.focus(), []);
  const list = searchApps(q, appsFor(admin));
  const pos = at === 'rail' ? s.apAtRail : at === 'float' ? s.apAtFloat : s.apAtSide;
  return (
    <>
      <div className={s.scrimClear} style={{ zIndex: 57 }} onClick={onClose} />
      <div role="menu" aria-label={t('shell.zones')} className={`${s.apps} ${pos}`} onKeyDown={(e) => e.key === 'Escape' && onClose()}>
        <div className={s.apHead}>
          <b>HANA Hub</b>
          <button type="button" className={s.ib} aria-label={t('common.close')} onClick={onClose}>
            <IconX size={15} />
          </button>
        </div>
        <label className={s.apQ}>
          <IconSearch size={15} />
          <input ref={box} aria-label={t('shell.findZone')} placeholder={t('shell.findZonePh')} value={q} onChange={(e) => setQ(e.target.value)} />
        </label>
        {list.length === 0 && <div className={s.apNone}>{t('shell.noZone', { q })}</div>}
        <div className={s.apGrid}>
          {list.map((a) => {
            const on = a.key === current;
            return (
              <a key={a.key} role="menuitem" href={a.path} className={s.ap} aria-current={on ? 'page' : undefined} aria-label={a.name + (on ? t('shell.current') : '')} title={a.desc}>
                <AppIcon app={a.key} size={36} />
                <b>{a.name}</b>
                <span>{a.desc}</span>
              </a>
            );
          })}
        </div>
        <a role="menuitem" href="/home" className={s.apHub}>
          <AppIcon app="hub" size={18} />
          <span>{t('shell.allZones')}</span>
          <IconArrowUpRight size={15} color="var(--lb)" aria-hidden="true" />
        </a>
      </div>
    </>
  );
}

/** Hàng 6 vùng trong bảng "Thêm" của điện thoại. */
export function AppsRow({ current, admin = false }: { current: AppKey; admin?: boolean }) {
  const t = useT();
  return (
    <div className={s.apRow} role="group" aria-label="HANA Hub">
      {appsFor(admin).map((a) => {
        const on = a.key === current;
        return (
          <a key={a.key} href={a.path} className={s.apMini} aria-current={on ? 'page' : undefined} aria-label={a.name + (on ? t('shell.current') : '')}>
            <AppIcon app={a.key} size={40} />
            {a.short}
          </a>
        );
      })}
    </div>
  );
}
